/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { $ } from './tokens.stylex';

export const dark = stylex.createTheme($, {
  textPrimary: '#FFFFFFFF',
  textSecondary: '#C5C5C9FF',
  textTertiary: '#8A8A8DFF',
  textQuaternary: '#8A8A8DFF',
  textPlaceholder: '#6D6E71FF',
  textDisabled: '#383838FF',
  textInverted: '#09090AFF',
  textInteractive: '#A9B1F9FF',
  textInteractiveHover: '#8288F2FF',
  textCritical: '#E17E78FF',
  textCriticalHover: '#D24242FF',
  textWhite: '#FFFFFFFF',
  textBlack: '#09090AFF',
  textPositive: '#67BE82FF',
  textPositiveHover: '#0A9E60FF',
  iconPrimary: '#FFFFFFFF',
  iconSecondary: '#C5C5C9FF',
  iconTertiary: '#8A8A8DFF',
  iconQuaternary: '#5B5B5EFF',
  iconDisabled: '#383838FF',
  iconInverted: '#09090AFF',
  iconInteractive: '#A9B1F9FF',
  iconPositive: '#67BE82FF',
  iconAttentive: '#ECC727FF',
  iconDestructive: '#E17E78FF',
  iconWhite: '#FFFFFFFF',
  iconBlack: '#09090AFF',
  border04: '#FFFFFF0F',
  border06: '#FFFFFF14',
  border08: '#FFFFFF1F',
  border10: '#FFFFFF29',
  border12: '#FFFFFF33',
  border16: '#FFFFFF3D',
  border20: '#FFFFFF47',
  border24: '#FFFFFF52',
  borderContrast: '#FFFFFFFF',
  borderContrastInverted: '#09090AFF',
  borderInteractive: '#8288F2FF',
  borderInteractiveSilent: '#2A2A57FF',
  borderPositive: '#67BE82FF',
  borderAttentive: '#ECC727FF',
  borderCritical: '#E17E78FF',
  borderBlack: '#09090AFF',
  borderWhite: '#FFFFFFFF',
  surfaceBGPrimary: '#09090AFF',
  surfaceBGSecondary: '#1D1D1EFF',
  surfaceBGAlternative01: '#1D1D1EFF',
  surfaceBGAlternative02: '#09090AFF',
  surface00: '#09090AFF',
  surface01: '#131313FF',
  surface02: '#1D1D1EFF',
  surface03: '#323232FF',
  surface04: '#383838FF',
  surface05: '#3B3B3CFF',
  surfaceContrast: '#FFFFFFFF',
  surfaceContrastInverted: '#09090AFF',
  surfaceBlack: '#09090AFF',
  surfaceWhite: '#FFFFFFFF',
  surfaceHighlight: '#5B63F0FF',
  surfaceHighlightMedium: '#2A2A57FF',
  surfaceHighlightSilent: '#15152AFF',
  surfacePositive: '#2DAC6FFF',
  surfacePositiveMedium: '#0B3020FF',
  surfacePositiveSilent: '#042214FF',
  surfaceAttentive: '#ECC727FF',
  surfaceAttentiveMedium: '#665123FF',
  surfaceAttentiveSilent: '#B795001F',
  surfaceCritical: '#D24242FF',
  surfaceCriticalMedium: '#3D0D0DFF',
  surfaceCriticalSilent: '#3D0A05FF',
  opacity02: '#FFFFFF0A',
  opacity04: '#FFFFFF0F',
  opacity06: '#FFFFFF14',
  opacity08: '#FFFFFF1F',
  opacity10: '#FFFFFF24',
  opacity12: '#FFFFFF29',
  opacity16: '#FFFFFF33',
  opacity20: '#FFFFFF33',
  opacity24: '#FFFFFF3D',
  opacity32: '#FFFFFF52',
  opacity40: '#FFFFFF66',
  opacity48: '#FFFFFF7A',
  opacity64: '#FFFFFFA3',
  opacity72: '#FFFFFFB8',
  opacity80: '#FFFFFFCC',
  opacity88: '#FFFFFFE0',
  opacity96: '#FFFFFFF5',
  opacity10Inverted: '#0000001A',
  accentSun10: '#B795001F',
  accentSun60: '#FFC111FF',
  accentSun80: '#FFDC44FF',
  accentPumpkin10: '#FF950024',
  opacity12Inverted: '#0000001F',
  opacity32Inverted: '#00000052',
  accentPumpkin60: '#FF990AFF',
  accentPumpkin80: '#FF922DFF',
  accentChilli10: '#FF18182E',
  accentChilli60: '#FF4B32FF',
  accentChilli80: '#FF5252FF',
  accentPlum10: '#8323FA3B',
  buttonContentPrimary: '#FFFFFFFF',
  accentPlum60: '#A256FFFF',
  accentPlum80: '#B77DFFFF',
  accentSky10: '#205EFF3D',
  buttonContentPrimaryHover: '#FFFFFFFF',
  accentSky60: '#5D81FFFF',
  accentSky80: '#88A9FFFF',
  buttonContentPrimaryMono: '#09090AFF',
  buttonContentPrimaryMonoHover: '#09090AFF',
  buttonContentSecondary: '#FFFFFFFF',
  buttonContentSecondaryHover: '#FFFFFFFF',
  buttonContentTertiary: '#C8CFFFFF',
  buttonContentTertiaryHover: '#C8CFFFFF',
  buttonContentQuaternary: '#A5A6A9FF',
  buttonContentQuaternaryHover: '#E3E5E8FF',
  buttonContentAlternative: '#FFFFFFFF',
  buttonContentAlternativeHover: '#FFFFFFFF',
  buttonContentGhostPrimary: '#A5A6A9FF',
  buttonContentGhostSecondary: '#5B5B5EFF',
  buttonContentGhostHover: '#C8CFFFFF',
  buttonContentGhostDestructiveHover: '#E17E78FF',
  buttonContentDisabled: '#FFFFFF3D',
  buttonSurfacePrimary: '#636CF3FF',
  buttonSurfacePrimaryHover: '#8288F2FF',
  buttonSurfacePrimaryMono: '#FFFFFFFF',
  buttonSurfacePrimaryMonoHover: '#F9FAFAFF',
  buttonSurfaceSecondary: '#FFFFFF29',
  buttonSurfaceSecondaryHover: '#FFFFFF3D',
  buttonSurfaceTertiary: '#2A2A57FF',
  buttonSurfaceTertiaryHover: '#38396FFF',
  buttonSurfaceTertiaryPressed: '#38396FFF',
  accentOcean10: '#00A4EA29',
  buttonSurfaceQuaternary: '#FFFFFF1F',
  buttonSurfaceQuaternaryHover: '#FFFFFF29',
  buttonSurfaceAlternative: '#323232FF',
  buttonSurfaceAlternativeHover: '#3B3B3CFF',
  buttonSurfaceAttentive: '#ECC727FF',
  buttonSurfaceCritical: '#D24242FF',
  buttonSurfaceDisabled: '#FFFFFF1F',
  buttonSurfaceGhostHover: '#15152AFF',
  buttonSurfaceGhostDestructiveHover: '#3D0D0DFF',
  opacity80Inverted: '#000000CC',
  accentOcean60: '#00B3FFFF',
  accentOcean80: '#58C1EEFF',
  accentTurquoise10: '#00C6BF29',
  accentTurquoise60: '#00E4DCFF',
  accentTurquoise80: '#51D7D3FF',
  accentCucumber10: '#1EEA6029',
  accentCucumber60: '#19D95AFF',
  accentCucumber80: '#55CC7CFF',
  accentBeetroot10: '#C59DAB24',
  accentBeetroot60: '#C7AFB8FF',
  accentBeetroot80: '#8E6070FF',
  opacity88Inverted: '#000000E0',
  shadowBottom010Loud: '0px 1px 1px 0px rgba(0, 0, 0, 0.64)',
  shadowBottom010Medium: '0px 1px 1px 0px rgba(0, 0, 0, 0.40)',
  shadowBottom010Silent: '0px 1px 1px 0px rgba(0, 0, 0, 0.20)',
  shadowBottom020Loud: '0px 1px 2px 0px rgba(0, 0, 0, 0.64)',
  shadowBottom020Medium: '0px 1px 2px 0px rgba(0, 0, 0, 0.40)',
  shadowBottom020Silent: '0px 1px 2px 0px rgba(0, 0, 0, 0.20)',
  shadowBottom030Loud: '0px 1.5px 3px 0px rgba(0, 0, 0, 0.64)',
  shadowBottom030Medium: '0px 1.5px 3px 0px rgba(0, 0, 0, 0.40)',
  shadowBottom030Silent: '0px 1.5px 3px 0px rgba(0, 0, 0, 0.20)',
  shadowBottom040Loud: '0px 4px 6px 0px rgba(0, 0, 0, 0.44)',
  shadowBottom040Medium: '0px 4px 6px 0px rgba(0, 0, 0, 0.30)',
  shadowBottom040Silent: '0px 2.5px 5px 0px rgba(0, 0, 0, 0.16)',
  shadowBottom050Loud: '0px 4px 16px 0px rgba(0, 0, 0, 0.58)',
  shadowBottom050Medium: '0px 4px 16px 0px rgba(0, 0, 0, 0.34)',
  shadowBottom050Silent: '0px 12px 20px 0px rgba(0, 0, 0, 0.16)',
  shadowBottom060Loud: '0px 12px 20px 0px rgba(0, 0, 0, 0.48)',
  shadowBottom060Medium: '0px 12px 20px 0px rgba(0, 0, 0, 0.34)',
  shadowBottom060Silent: '0px 2px 6px 0px rgba(0, 0, 0, 0.20)',
  shadowBottom070Loud: '0px 32px 40px 0px rgba(0, 0, 0, 0.44)',
  shadowBottom070Medium: '0px 32px 40px 0px rgba(0, 0, 0, 0.28)',
  shadowBottom070Silent: '0px 32px 40px 0px rgba(0, 0, 0, 0.16)',
  shadowBottom080Loud: '0px 48px 48px 0px rgba(0, 0, 0, 0.44)',
  shadowBottom080Medium: '0px 48px 48px 0px rgba(0, 0, 0, 0.32)',
  shadowBottom080Silent: '0px 48px 48px 0px rgba(0, 0, 0, 0.14)',
  shadowBottom090Loud: '0px 48px 72px 0px rgba(0, 0, 0, 0.50)',
  shadowBottom090Medium: '0px 48px 72px 0px rgba(0, 0, 0, 0.28)',
  shadowBottom090Silent: '0px 48px 72px 0px rgba(0, 0, 0, 0.12)',
  shadowCenter010Loud: '0px 0px 1px 1px rgba(0, 0, 0, 0.80)',
  shadowCenter010Medium: '0px 0px 1px 1px rgba(0, 0, 0, 0.64)',
  shadowCenter010Silent: '0px 0px 1px 1px rgba(0, 0, 0, 0.32)',
  shadowCenter020Loud: '0px 0px 2px 0px rgba(0, 0, 0, 0.64)',
  shadowCenter020Medium: '0px 0px 2px 0px rgba(0, 0, 0, 0.40)',
  shadowCenter020Silent: '0px 0px 2px 0px rgba(0, 0, 0, 0.20)',
  shadowCenter030Loud: '0px 0px 3px 0px rgba(0, 0, 0, 0.64)',
  shadowCenter030Medium: '0px 0px 3px 0px rgba(0, 0, 0, 0.40)',
  shadowCenter030Silent: '0px 0px 3px 0px rgba(0, 0, 0, 0.20)',
  shadowCenter040Loud: '0px 0px 6px 0px rgba(0, 0, 0, 0.58)',
  shadowCenter040Medium: '0px 0px 6px 0px rgba(0, 0, 0, 0.30)',
  shadowCenter040Silent: '0px 0px 6px 0px rgba(0, 0, 0, 0.16)',
  shadowCenter050Loud: '0px 0px 14px 0px rgba(0, 0, 0, 0.58)',
  shadowCenter050Medium: '0px 0px 14px 0px rgba(0, 0, 0, 0.30)',
  shadowCenter050Silent: '0px 0px 14px 0px rgba(0, 0, 0, 0.16)',
  shadowCenter060Loud: '0px 0px 20px 0px rgba(0, 0, 0, 0.34)',
  shadowCenter060Medium: '0px 0px 20px 0px rgba(0, 0, 0, 0.34)',
  shadowCenter060Silent: '0px 0px 20px 0px rgba(0, 0, 0, 0.16)',
  shadowCenter070Loud: '0px 0px 40px 0px rgba(0, 0, 0, 0.44)',
  shadowCenter070Medium: '0px 0px 40px 0px rgba(0, 0, 0, 0.28)',
  shadowCenter070Silent: '0px 0px 40px 0px rgba(0, 0, 0, 0.16)',
  shadowCenter080Loud: '0px 0px 48px 0px rgba(0, 0, 0, 0.52)',
  shadowCenter080Medium: '0px 0px 48px 0px rgba(0, 0, 0, 0.32)',
  shadowCenter080Silent: '0px 0px 48px 0px rgba(0, 0, 0, 0.14)',
  shadowCenter090Loud: '0px 0px 72px 0px rgba(0, 0, 0, 0.64)',
  shadowCenter090Medium: '0px 0px 72px 0px rgba(0, 0, 0, 0.28)',
  shadowCenter090Silent: '0px 0px 72px 0px rgba(0, 0, 0, 0.12)',
  shadowTop010Loud: '0px -1px 1px 0px rgba(0, 0, 0, 0.64)',
  shadowTop010Medium: '0px -1px 1px 0px rgba(0, 0, 0, 0.40)',
  shadowTop010Silent: '0px -1px 1px 0px rgba(0, 0, 0, 0.20)',
  shadowTop020Loud: '0px -1px 2px 0px rgba(0, 0, 0, 0.64)',
  shadowTop020Medium: '0px -1px 2px 0px rgba(0, 0, 0, 0.40)',
  shadowTop020Silent: '0px -1px 2px 0px rgba(0, 0, 0, 0.20)',
  shadowTop030Loud: '0px -1.5px 3px 0px rgba(0, 0, 0, 0.64)',
  shadowTop030Medium: '0px -1.5px 3px 0px rgba(0, 0, 0, 0.40)',
  shadowTop030Silent: '0px -1.5px 3px 0px rgba(0, 0, 0, 0.20)',
  shadowTop040Loud: '0px -4px 6px 0px rgba(0, 0, 0, 0.44)',
  shadowTop040Medium: '0px -4px 6px 0px rgba(0, 0, 0, 0.30)',
  shadowTop040Silent: '0px -2.5px 5px 0px rgba(0, 0, 0, 0.16)',
  shadowTop050Loud: '0px -4px 16px 0px rgba(0, 0, 0, 0.58)',
  shadowTop050Medium: '0px -4px 16px 0px rgba(0, 0, 0, 0.34)',
  shadowTop050Silent: '0px -4px 16px 0px rgba(0, 0, 0, 0.16)',
  shadowTop060Loud: '0px -12px 20px 0px rgba(0, 0, 0, 0.48)',
  shadowTop060Medium: '0px -12px 20px 0px rgba(0, 0, 0, 0.34)',
  shadowTop060Silent: '0px -12px 20px 0px rgba(0, 0, 0, 0.16)',
  shadowTop070Loud: '0px -32px 40px 0px rgba(0, 0, 0, 0.44)',
  shadowTop070Medium: '0px -32px 40px 0px rgba(0, 0, 0, 0.28)',
  shadowTop070Silent: '0px -32px 40px 0px rgba(0, 0, 0, 0.16)',
  shadowTop080Loud: '0px -48px 48px 0px rgba(0, 0, 0, 0.44)',
  shadowTop080Medium: '0px -48px 48px 0px rgba(0, 0, 0, 0.32)',
  shadowTop080Silent: '0px -48px 48px 0px rgba(0, 0, 0, 0.14)',
  shadowTop090Loud: '0px -48px 72px 0px rgba(0, 0, 0, 0.50)',
  shadowTop090Medium: '0px -48px 72px 0px rgba(0, 0, 0, 0.28)',
  shadowTop090Silent: '0px -48px 72px 0px rgba(0, 0, 0, 0.12)',
  tableRowBgAlternating: 'linear-gradient(0deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.03) 100%)',
});

export const solveLight = stylex.createTheme($, {
  textPrimary: '#0A0A0AFF',
  textSecondary: '#515258FF',
  textTertiary: '#696969FF',
  textQuaternary: '#878787FF',
  textPlaceholder: '#9E9E9EFF',
  textDisabled: '#DCDCDCFF',
  textInverted: '#FFFFFFFF',
  textInteractive: '#006D9CFF',
  textInteractiveHover: '#006D9CFF',
  textCritical: '#CD3535FF',
  textCriticalHover: '#7D1A1AFF',
  textWhite: '#FFFFFFFF',
  textBlack: '#0A0A0AFF',
  textPositive: '#288344FF',
  textPositiveHover: '#1D6F37FF',
  iconPrimary: '#0A0A0AFF',
  iconSecondary: '#636363FF',
  iconTertiary: '#878787FF',
  iconQuaternary: '#B2B2B2FF',
  iconDisabled: '#DCDCDCFF',
  iconInverted: '#FFFFFFFF',
  iconInteractive: '#006D9CFF',
  iconPositive: '#288344FF',
  iconAttentive: '#F2CC22FF',
  iconDestructive: '#CD3535FF',
  iconWhite: '#FFFFFFFF',
  iconBlack: '#0A0A0AFF',
  border04: '#0000000A',
  border06: '#0000000F',
  border08: '#00000014',
  border10: '#0000001A',
  border12: '#0000001F',
  border16: '#00000029',
  border20: '#00000033',
  border24: '#0000003D',
  borderContrast: '#0A0A0AFF',
  borderContrastInverted: '#FFFFFFFF',
  borderInteractive: '#006D9CFF',
  borderInteractiveSilent: '#D4DFFFFF',
  borderPositive: '#4AAA69FF',
  borderAttentive: '#F2CC22FF',
  borderCritical: '#CD3535FF',
  borderBlack: '#0A0A0AFF',
  borderWhite: '#FFFFFFFF',
  surfaceBGPrimary: '#FFFFFFFF',
  surfaceBGSecondary: '#F8F8FBFF',
  surfaceBGAlternative01: '#FFFFFFFF',
  surfaceBGAlternative02: '#F3F3F3FF',
  surface00: '#FFFFFFFF',
  surface01: '#F8F8FBFF',
  surface02: '#F3F3F3FF',
  surface03: '#EAEAEAFF',
  surface04: '#DCDCDCFF',
  surface05: '#CBCBCBFF',
  surfaceContrast: '#0A0A0AFF',
  surfaceContrastInverted: '#FFFFFFFF',
  surfaceBlack: '#0A0A0AFF',
  surfaceWhite: '#FFFFFFFF',
  surfaceHighlight: '#006D9CFF',
  surfaceHighlightMedium: '#00A4EA24',
  surfaceHighlightSilent: '#00A4EA14',
  surfacePositive: '#4AAA69FF',
  surfacePositiveMedium: '#DFF2E5FF',
  surfacePositiveSilent: '#DFF2E5FF',
  surfaceAttentive: '#F2CC22FF',
  surfaceAttentiveMedium: '#FFEBACFF',
  surfaceAttentiveSilent: '#FFF7E0FF',
  surfaceCritical: '#CD3535FF',
  surfaceCriticalMedium: '#FCD3CFFF',
  surfaceCriticalSilent: '#FFEAEAFF',
  opacity02: '#00000005',
  opacity04: '#0000000A',
  opacity06: '#0000000F',
  opacity08: '#00000014',
  opacity10: '#0000001A',
  opacity12: '#0000001F',
  opacity16: '#00000029',
  opacity20: '#00000033',
  opacity24: '#0000003D',
  opacity32: '#00000052',
  opacity40: '#00000066',
  opacity48: '#0000007A',
  opacity64: '#000000A3',
  opacity72: '#000000B8',
  opacity80: '#000000CC',
  opacity88: '#000000E0',
  opacity96: '#000000F5',
  opacity10Inverted: '#FFFFFF1A',
  accentSun10: '#FFBD001F',
  accentSun60: '#F0B200FF',
  accentSun80: '#725C00FF',
  accentPumpkin10: '#FF950133',
  opacity12Inverted: '#FFFFFF1F',
  opacity32Inverted: '#FFFFFF52',
  accentPumpkin60: '#FF7B01FF',
  accentPumpkin80: '#B55700FF',
  accentChilli10: '#FF1F001F',
  accentChilli60: '#FF4B32FF',
  accentChilli80: '#CD3535FF',
  accentPlum10: '#5600C221',
  buttonContentPrimary: '#FFFFFFFF',
  accentPlum60: '#8A2BFFFF',
  accentPlum80: '#6635A3FF',
  accentSky10: '#0060FF1F',
  buttonContentPrimaryHover: '#FFFFFFFF',
  accentSky60: '#307EFFFF',
  accentSky80: '#375FC4FF',
  buttonContentPrimaryMono: '#FFFFFFFF',
  buttonContentPrimaryMonoHover: '#FFFFFFFF',
  buttonContentSecondary: '#0A0A0AFF',
  buttonContentSecondaryHover: '#0A0A0AFF',
  buttonContentTertiary: '#006D9CFF',
  buttonContentTertiaryHover: '#006D9CFF',
  buttonContentQuaternary: '#878787FF',
  buttonContentQuaternaryHover: '#515258FF',
  buttonContentAlternative: '#0A0A0AFF',
  buttonContentAlternativeHover: '#0A0A0AFF',
  buttonContentGhostPrimary: '#6D6E71FF',
  buttonContentGhostSecondary: '#CBCBCBFF',
  buttonContentGhostHover: 'undefined',
  buttonContentGhostDestructiveHover: '#CD3535FF',
  buttonContentDisabled: '#00000029',
  buttonSurfacePrimary: '#006D9CFF',
  buttonSurfacePrimaryHover: '#006D9CFF',
  buttonSurfacePrimaryMono: '#0A0A0AFF',
  buttonSurfacePrimaryMonoHover: '#38393FFF',
  buttonSurfaceSecondary: '#0000000F',
  buttonSurfaceSecondaryHover: '#0000001A',
  buttonSurfaceTertiary: '#00A4EA24',
  buttonSurfaceTertiaryHover: '#00A4EA38',
  buttonSurfaceTertiaryPressed: '#00A4EA38',
  accentOcean10: '#00A4EA24',
  buttonSurfaceQuaternary: '#FFFFFFFF',
  buttonSurfaceQuaternaryHover: '#0000000F',
  buttonSurfaceAlternative: '#FFFFFFFF',
  buttonSurfaceAlternativeHover: '#EAEAEAFF',
  buttonSurfaceAttentive: '#F2CC22FF',
  buttonSurfaceCritical: '#CD3535FF',
  buttonSurfaceDisabled: '#0000000F',
  buttonSurfaceGhostHover: '#00A4EA24',
  buttonSurfaceGhostDestructiveHover: '#FFEAEAFF',
  opacity80Inverted: '#FFFFFFCC',
  accentOcean60: '#00ABF5FF',
  accentOcean80: '#006D9CFF',
  accentTurquoise10: '#00C6BF29',
  accentTurquoise60: '#00B8B2FF',
  accentTurquoise80: '#007773FF',
  accentCucumber10: '#00C74124',
  accentCucumber60: '#1FBB54FF',
  accentCucumber80: '#177335FF',
  accentBeetroot10: '#AF939D33',
  accentBeetroot60: '#AF939DFF',
  accentBeetroot80: '#7C4D5EFF',
  opacity88Inverted: '#FFFFFFE0',
  tableRowBgAlternating: 'linear-gradient(0deg, rgba(0, 0, 0, 0.01) 0%, rgba(0, 0, 0, 0.01) 100%)',
});
